import Network from '../network.js'

export default {
  capture(request) {
    return Network.post('/sessions/capture', request, true)
  }
}
